import React, { useRef, useState, useContext } from "react";
import ReactGA from "react-ga4";

import { Transition } from "react-transition-group";
import Button from "../form-components/button";

import {
  createMailInFirestoreDb,
  updatePrayerInFirestoreDb,
} from "../../utils/firebase-utils";

import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./prayer.styles.css";
import { ConfirmDeleteModalContext } from "../../contexts/confirm-delete-modal-context";
import { PrayerIdContext } from "../../contexts/prayer-id-context";

const Prayer = ({ prayer }) => {
  const [inProp, setInProp] = useState(true);
  const [hidePrayer, setHidePrayer] = useState(false);
  const nodeRef = useRef(null);

  const { setOpenConfirmDeleteModal } = useContext(ConfirmDeleteModalContext);
  const { setPrayerId } = useContext(PrayerIdContext);

  const storageUser = localStorage.getItem("user");
  const currentUser = JSON.parse(storageUser);

  const isUsersPrayer = prayer.userUid === currentUser?.uid;
  const shouldShowDeleteButton = currentUser?.role === "admin" || isUsersPrayer;

  const rawPrayerDate = new Date(prayer.createdAtTimestamp);
  const prayerDate = formatDate(rawPrayerDate);

  const now = new Date().getTime();
  const lastPrayedTimestamp = prayer.lastPrayedTimestamp;
  const lastPrayedDiff =
    lastPrayedTimestamp > 0
      ? millisecondsToTimeperiod(now - lastPrayedTimestamp)
      : null;

  const recipientEmail = prayer.email ? prayer.email : null;
  const recipientName =
    prayer.displayName === "Anonymous" ? "" : prayer.displayName;

  const handleIPrayedClick = async () => {
    const now = new Date().getTime();

    ReactGA.event({
      category: "prayer-actions",
      action: "im-praying-click",
    });

    setInProp(false);
    setHidePrayer(true);

    await updatePrayerInFirestoreDb(prayer.prayerId, now);

    if (prayer.receiveEmailUpdates && recipientEmail) {
      await createMailInFirestoreDb(
        recipientEmail,
        recipientName,
        prayer.message,
        false
      );
    }
  };

  const handleDeletePrayerClick = async () => {
    setPrayerId(prayer.prayerId);
    setOpenConfirmDeleteModal(true);
  };

  return (
    <Transition
      nodeRef={nodeRef}
      in={inProp}
      timeout={500}
      unmountOnExit={true}
    >
      <div ref={nodeRef} style={{ display: "flex" }}>
        <div className={`prayer-card ${hidePrayer ? "inactive" : "active"}`}>
          <div>
            <div className="prayer-card-header">
              <div>
                {prayer.displayName ? (
                  <h3 className="prayer-heading">{prayer.displayName}</h3>
                ) : (
                  <h3 className="prayer-heading">Anonymous</h3>
                )}
              </div>
              <div>
                {shouldShowDeleteButton ? (
                  <Button
                    type="button"
                    className="prayer-delete-button"
                    onClick={handleDeletePrayerClick}
                  >
                    <FontAwesomeIcon
                      icon={faCircleXmark}
                      size="xl"
                      style={{ color: "#F4E8D4" }}
                    />
                  </Button>
                ) : null}
              </div>
            </div>

            <div className="prayer-message">{prayer.message}</div>
          </div>

          <div className="prayer-footer">
            <div className="prayer-footer-text">
              <div className="prayer-date">{prayerDate}</div>
              <div className="prayer-timestamp">
                {lastPrayedDiff ? (
                  <div>{`Last prayer: ${lastPrayedDiff}`}</div>
                ) : null}
              </div>
            </div>
            <div className="prayer-buttons">
              <Button
                type="button"
                buttonType="orange"
                onClick={handleIPrayedClick}
              >
                I'm praying
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default Prayer;

const millisecondsToTimeperiod = (ms) => {
  let seconds = ms / 1000;
  const days = parseInt(seconds / 86400); // 86,400 seconds in a day
  seconds = seconds % 86400; // seconds remaining after extracting days
  const hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
  seconds = seconds % 3600; // seconds remaining after extracting hours
  const minutes = parseInt(seconds / 60); // 60 seconds in 1 minute

  // TODO refactor this!
  if (hours === 0 && minutes <= 1) return `just now`;
  if (hours === 0 && minutes === 1) return `${minutes} minute ago`;
  if (hours === 0 && minutes > 1) return `${minutes} minutes ago`;
  if (hours === 1) return `${hours} hour ago`;
  if (hours > 1 && hours < 24) return `${hours} hours ago`;
  if (hours >= 24 && days === 1) return `${days} day ago`;
  if (hours >= 24 && days > 1) return `${days} days ago`;
};

const formatDate = (rawDate) => {
  const dayOptions = { weekday: "short" };
  const dateOptions = { month: "short", day: "numeric" };

  const day = rawDate.toLocaleDateString("en-UK", dayOptions);
  const date = rawDate.toLocaleDateString("en-UK", dateOptions);

  return `${day} ${date}`;
};
